export default "__VITE_ASSET__DfOiPh86__";